/** @format */

import React, { PureComponent, SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { TableRow } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import { PlusOrdersCommonResponse } from '../../../interfaces/platform/PlusOrdersCommonResponse';
import ViewButton from '../../../components/Buttons/ViewButton';
import SimCardButton from '../../../components/Buttons/SimCardButton';
import BlockOperationButton from '../../../components/Buttons/BlockOperationButton';
import { DateHelper } from '../../../helpers/DateHelper';
import PlatformResellerInterface from '../../../interfaces/platform/PlatformResellerInterface';
import MvnoBlockListInterface from '../../../interfaces/platform/MvnoBlockListInterface';
import { Auth, tokenInfo } from '../../../modules/auth/Auth';
import I18n from '../../../components/Translate/I18n';
import { history } from '../../../core/history';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';

const _ = require('underscore');

interface PlkListItemPropsInterface {
    classes: any;
    dispatch: any;
    item: PlusOrdersCommonResponse;
    platformResellerList: Array<PlatformResellerInterface> | null;
    mvnoBlockList: Array<MvnoBlockListInterface>;

    viewPlkMessage(item: PlusOrdersCommonResponse): void;

    setActiveRow: (id: number) => void;
    rowActiveColor: string;
}

interface PlkListItemStateInterface {
    viewDialog: boolean;
}

class PlkListItem extends PureComponent<PlkListItemPropsInterface, PlkListItemStateInterface> {
    constructor(props: PlkListItemPropsInterface, context: PlkListItemStateInterface) {
        super(props, context);

        this.state = {
            viewDialog: false,
        };
    }

    getPlatformResellerName = (platformResellerId: number): string | null => {
        const { platformResellerList } = this.props;
        if (!platformResellerList) {
            return null;
        }
        for (let i = 0; i < platformResellerList.length; i++) {
            if (platformResellerList[i].id === platformResellerId) {
                return platformResellerList[i].mainname;
            }
        }
        return null;
    };

    getMvnoBlockListName = (mvnoBlockListNameId: number): string | null => {
        const { mvnoBlockList } = this.props;
        for (let i = 0; i < mvnoBlockList.length; i++) {
            if (mvnoBlockList[i].id === mvnoBlockListNameId) {
                return mvnoBlockList[i].blockName;
            }
        }
        return null;
    };

    callViewDetail = (): void => {
        const { item, viewPlkMessage } = this.props;
        viewPlkMessage(item);
    };

    callViewSimCard = (params: { uri: string | null }, event?: SyntheticEvent): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, FormGeneralHelper.getRouteUrl('/sim-card-edit' + params.uri));
    };

    callViewBlockOperations = (params: { blockId: number }, event?: SyntheticEvent): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(
            event,
            FormGeneralHelper.getRouteUrl('/block-request-detail/adescom-api/api/platform/mvno_block_requests/' + params.blockId)
        );
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { item, classes, rowActiveColor, setActiveRow } = this.props;
        const tableCellRoot = { root: classes.tableCellRootBordered };
        const tableRowRoot = {root: classes.tableRowRoot};
        const tableStickyCommand = {root: classes.tableStickyCommand};

        let errorStatus = 'ok';
        if (item.errorStatus) {
            errorStatus = 'error';
        }

        return (
            <TableRow
                onClick={(): void => {
                    setActiveRow(item.id);
                }}
                classes={tableRowRoot}
                style={{ backgroundColor: rowActiveColor }}
                hover
            >
                <TableCell classes={tableStickyCommand} padding="none" align="left">
                    <ViewButton callback={this.callViewDetail} tooltipTitle="prov:list.view"
                                tooltipPlacement="bottom-start" callbackParam={{}}/>
                    <SimCardButton
                        callback={this.callViewSimCard}
                        tooltipTitle="prov:list.msisdn_view"
                        tooltipPlacement="bottom-start"
                        callbackParam={{uri: item.simCard}}
                    />
                    {Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && item.mvnoBlockListId && (
                        <BlockOperationButton
                            callback={this.callViewBlockOperations}
                            tooltipTitle="prov:list.block_list"
                            tooltipPlacement="bottom-start"
                            callbackParam={{ blockId: item.mvnoBlockRequestId }}
                        />
                    )}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {item.id}
                </TableCell>
                {/*{Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && (*/}
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {this.getPlatformResellerName(item.platformResellerId)}
                </TableCell>
                {/*)}*/}
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {item.mvnoBlockRequestId}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {item.mvnoBlockListId && <I18n trans={'prov:b.' + this.getMvnoBlockListName(item.mvnoBlockListId)} />}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {item.command !== 'REST_API_CALL' && item.command}
                    {item.command === 'REST_API_CALL' && 'GEN/GMLC/ApiRest'}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {item.msisdn}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {item.imsi}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {DateHelper.format(item.requestTime)}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {DateHelper.format(item.responseTime)}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    <I18n trans={'prov:state.' + errorStatus} />
                </TableCell>
            </TableRow>
        );
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(oplAppStyle)
)(PlkListItem);
